function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangedevLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "62.2453 210.7385 661.3 87.07",
    width: 661.3,
    height: 87.07,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.68,7.7v9.84H126.6c-2.97,0-5.44,0.82-7.42,2.46c-1.98,1.64-2.97,3.72-2.97,6.22v44.1h0 c-6.59,0-11.94-5.19-11.94-11.6V23.9c0-4.47,1.9-8.28,5.71-11.45c3.81-3.17,8.41-4.75,13.8-4.75H153.68z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.17,70.33V26.8c0-2.57-0.99-4.7-2.97-6.38c-1.98-1.68-4.45-2.52-7.42-2.52h-23.66 c-2.97,0-5.44,0.84-7.42,2.52c-1.98,1.68-2.97,3.81-2.97,6.38v17.96H235.8V24.42c0-4.58,1.9-8.5,5.71-11.77 c3.81-3.27,8.41-4.91,13.8-4.91h29.37c5.39,0,9.99,1.64,13.8,4.91c3.81,3.27,5.71,7.2,5.71,11.77v34.24 C304.19,65.1,298.81,70.33,292.17,70.33L292.17,70.33z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M453.72,44.89V24.42c0-4.58-1.9-8.49-5.71-11.74c-3.81-3.25-8.41-4.87-13.8-4.87h-28.33 c-5.39,0-9.99,1.62-13.8,4.87c-3.81,3.25-5.71,7.16-5.71,11.74v20.47v12.69c0,3.55,1.55,6.57,4.64,9.04 c3.09,2.48,6.84,3.71,11.24,3.71h39.87v-9.74h-37.79c-1.73,0-3.18-0.4-4.34-1.19c-1.16-0.79-1.74-1.82-1.74-3.08V44.89H453.72z M398.24,26.8c0-2.52,1-4.63,3-6.31c2-1.68,4.49-2.52,7.45-2.52h22.7c2.97,0,5.43,0.83,7.38,2.49c1.95,1.66,2.95,3.77,3,6.34v7.99 h-43.54V26.8z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M461.08,7.42v62.91h45.91c5.24,0,9.7-1.63,13.39-4.88c3.69-3.26,5.53-7.18,5.53-11.77V24.23 c0-4.59-1.84-8.51-5.53-11.77c-3.69-3.26-8.15-4.88-13.39-4.88h-34.42L461.08,7.42z M472.57,17.83 c18.66-0.09,29.61-0.14,32.85-0.14c2.57,0,4.71,0.89,6.43,2.67c1.71,1.78,2.57,3.89,2.57,6.33v24.6c0,2.53-0.95,4.64-2.86,6.32 c-1.9,1.69-4.31,2.53-7.21,2.53h-31.77V17.83z",
    style: {
      fill: "rgb(112, 111, 111)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M597.88,44.73v-20.6c0-4.61-1.83-8.54-5.5-11.81c-3.67-3.27-8.09-4.9-13.28-4.9h-27.28 c-5.19,0-9.62,1.63-13.28,4.9c-3.67,3.27-5.5,7.21-5.5,11.81v20.6v12.77c0,3.57,1.49,6.61,4.46,9.1c2.98,2.49,6.58,3.74,10.82,3.74 h38.17v-9.8h-36.17c-1.67,0-3.06-0.4-4.18-1.2c-1.12-0.8-1.68-1.83-1.68-3.1v-11.5H597.88z M544.47,26.53 c0-2.54,0.96-4.66,2.89-6.35c1.93-1.69,4.32-2.54,7.18-2.54h21.85c2.86,0,5.22,0.84,7.1,2.5c1.88,1.67,2.84,3.8,2.89,6.38v8.04 h-41.91V26.53z",
    style: {
      fill: "rgb(112, 111, 111)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "613.1,7.42 641.3,58.9 670.18,7.45 683.25,7.45 648.16,70.33 634.45,70.33 600.03,7.42 \t",
    style: {
      fill: "rgb(112, 111, 111)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331.26,7.74c-5.44,0-10.08,1.64-13.91,4.92c-3.83,3.28-5.75,7.25-5.75,11.91v29.88 c0,4.66,1.92,8.64,5.75,11.95c1.87,1.61,3.94,2.83,6.19,3.65V52.03V37.64V26.99c0-2.57,0.99-4.71,2.97-6.42 c1.98-1.71,4.47-2.57,7.49-2.57h33.01v19.63v23.37v10.34v3.21c0,2.47-0.89,4.61-2.67,6.42c-1.78,1.81-4,2.71-6.67,2.71h-34.38 v10.27h36.01c5.44,0,10.07-1.65,13.91-4.96c3.83-3.3,5.75-7.29,5.75-11.95v-5.7V7.74H331.26z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.69,7.74c-5.44,0-10.08,1.62-13.91,4.87c-3.83,3.25-5.75,7.16-5.75,11.74v29.37 c0,4.58,1.92,8.49,5.75,11.74c3.83,3.25,8.47,4.87,13.91,4.87h23.81v0c0-5.61-4.55-10.15-10.16-10.16h-10.9 c-3.02,0-5.51-0.84-7.49-2.52c-1.98-1.68-2.97-3.78-2.97-6.31V26.8c0-2.52,0.99-4.63,2.97-6.31c1.98-1.68,4.48-2.52,7.49-2.52 h33.01V56v4.17v10.16h11.94V7.74H180.69z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.15,89.73c0.35,0.46,0.53,1.01,0.53,1.66c0,0.95-0.38,1.68-1.15,2.2c-0.76,0.52-1.87,0.77-3.31,0.77h-5.85 V83.53h5.54c1.38,0,2.43,0.26,3.16,0.77c0.72,0.51,1.08,1.2,1.08,2.07c0,0.52-0.13,0.98-0.38,1.39c-0.25,0.41-0.61,0.73-1.08,0.97 C34.32,88.93,34.8,89.27,35.15,89.73z M28.4,85.74v2.09h2.11c1.03,0,1.55-0.35,1.55-1.05c0-0.69-0.52-1.04-1.55-1.04H28.4z M32.59,91.05c0-0.73-0.54-1.1-1.61-1.1H28.4v2.2h2.57C32.05,92.15,32.59,91.79,32.59,91.05z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.56,92v2.37h-8.7V83.53h8.5v2.37h-5.47v1.83h4.82v2.29h-4.82V92H58.56z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.33,83.53h1.55v10.84h-1.55V83.53z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.85,83.53v10.84h-1.27l-6.5-8.08v8.08h-1.55V83.53h1.27l6.5,8.08v-8.08H106.85z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.82,83.53v10.84h-1.27l-6.5-8.08v8.08h-1.55V83.53h1.27l6.5,8.08v-8.08H133.82z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.4,93.77c-0.88-0.48-1.57-1.14-2.07-1.99c-0.5-0.85-0.75-1.79-0.75-2.83c0-1.04,0.25-1.99,0.75-2.83 c0.5-0.85,1.19-1.51,2.07-1.99c0.88-0.48,1.86-0.72,2.96-0.72c1.08,0,2.06,0.24,2.94,0.72c0.88,0.48,1.56,1.14,2.06,1.98 c0.5,0.84,0.74,1.79,0.74,2.84c0,1.05-0.25,2-0.74,2.84c-0.5,0.84-1.18,1.5-2.06,1.98c-0.88,0.48-1.86,0.72-2.94,0.72 C155.26,94.49,154.28,94.25,153.4,93.77z M158.5,92.57c0.63-0.36,1.13-0.86,1.5-1.49c0.37-0.63,0.55-1.34,0.55-2.13 c0-0.78-0.18-1.49-0.55-2.13c-0.37-0.63-0.87-1.13-1.5-1.49c-0.63-0.36-1.35-0.54-2.15-0.54c-0.79,0-1.51,0.18-2.16,0.54 c-0.65,0.36-1.15,0.86-1.52,1.49c-0.37,0.63-0.55,1.35-0.55,2.13c0,0.79,0.18,1.49,0.55,2.13c0.37,0.63,0.87,1.13,1.52,1.49 c0.65,0.36,1.37,0.54,2.16,0.54C157.15,93.11,157.87,92.93,158.5,92.57z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.94,83.53l-4.75,10.84h-1.53l-4.77-10.84h1.67l3.9,8.9l3.93-8.9H187.94z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210.28,91.66h-5.76l-1.19,2.71h-1.59l4.91-10.84h1.53l4.92,10.84h-1.63L210.28,91.66z M209.74,90.42 l-2.34-5.31l-2.34,5.31H209.74z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.71,84.88H227v-1.35h8.96v1.35h-3.72v9.49h-1.53V84.88z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M252.05,83.53h1.55v10.84h-1.55V83.53z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.55,83.53l-4.75,10.84h-1.53l-4.77-10.84h1.67l3.9,8.9l3.93-8.9H280.55z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304.19,93.02v1.35h-7.86V83.53h7.65v1.35h-6.1v3.33h5.43v1.32h-5.43v3.5H304.19z",
    style: {
      fill: "rgb(232, 78, 15)"
    },
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 40.29533446275195, 203.31849973378326)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.75,24.08c0-0.01,0-0.03,0-0.04c0-0.06,0-0.12,0-0.18c0-0.01,0-0.02,0-0.04c0-0.06,0-0.11-0.01-0.17 c0-0.01,0-0.02,0-0.03c0-0.06-0.01-0.12-0.01-0.18c0-0.02,0-0.03,0-0.05c0-0.06-0.01-0.12-0.01-0.17c0-0.02,0-0.03,0-0.05 c0-0.05-0.01-0.09-0.01-0.14c0-0.02,0-0.04,0-0.06c0-0.05-0.01-0.11-0.01-0.16c0-0.02,0-0.05-0.01-0.07 c0-0.04-0.01-0.08-0.01-0.12c0-0.03-0.01-0.07-0.01-0.1c0-0.03-0.01-0.07-0.01-0.1c0-0.03-0.01-0.06-0.01-0.09 c-0.01-0.04-0.01-0.09-0.02-0.13c0-0.03-0.01-0.07-0.01-0.1c0-0.02-0.01-0.04-0.01-0.06c-0.01-0.06-0.02-0.12-0.03-0.19 c0-0.01,0-0.02-0.01-0.03c-0.02-0.12-0.04-0.24-0.06-0.36c0,0,0,0,0,0c-0.65-3.4-2.49-6.38-5.55-8.94 c-0.94-0.79-1.93-1.44-2.96-2.03c-0.07-0.04-0.14-0.08-0.21-0.12c-1.5-0.84-3.1-1.48-4.79-1.93c-0.1-0.03-0.21-0.06-0.31-0.08 c-0.26-0.06-0.51-0.15-0.77-0.21c-0.01,0.01-0.03,0.03-0.04,0.04c-1.56-0.32-3.18-0.5-4.89-0.5h-0.2H52.02 c0.64,0.58,1.25,1.2,1.81,1.85c1.64,1.87,2.95,4.08,3.75,6.54c0.19,0.56,0.36,1.14,0.5,1.72c0,0.02,0.01,0.03,0.01,0.05H68.9 c-0.01,0.01-0.02,0.01-0.02,0.02c0.32,0,0.64,0.01,0.96,0.01c0,0,0,0,0,0c0.43,0,0.85,0.01,1.28,0.01h0c0,0,0,0,0,0 c0.37,0.01,0.72,0.02,1.07,0.05c0,0,0,0,0,0c2.57,0.21,4.74,1.05,6.49,2.51c1.4,1.17,2.31,2.55,2.73,4.14c0,0,0,0,0,0 c0.15,0.59,0.24,1.2,0.26,1.85c0,0.01,0,0.02,0,0.02c0,0.03,0,0.07,0,0.1c0,0.01,0,0.02,0,0.03c0,0.04,0,0.08,0,0.13 c0,0,0,0,0,0.01v24.47c0,2.52-1,4.61-3,6.27c-0.01,0.01-0.02,0.02-0.03,0.02c-0.3,0.25-0.59,0.53-0.88,0.8 c-1.67,1.12-3.65,1.73-5.94,1.84c0,0,0,0,0,0c-0.08,0-0.16,0.01-0.24,0.01c-0.03,0-0.05,0-0.08,0c-0.05,0-0.11,0-0.16,0 c-0.08,0-0.16,0-0.24,0H44.59c-0.08,0-0.16,0-0.24,0c-0.05,0-0.11,0-0.16,0c-0.03,0-0.05,0-0.08,0c-0.08,0-0.16-0.01-0.24-0.01 c0,0,0,0,0,0c-2.3-0.11-4.28-0.72-5.94-1.84c-0.28-0.27-0.57-0.55-0.88-0.8c-0.01-0.01-0.02-0.02-0.03-0.02c-2-1.66-3-3.75-3-6.27 V40.77c-4.61-0.46-8.86-2.57-12.07-5.73v18.61v0.04c0,0.07,0,0.14,0,0.21c0.06,4.49,2,8.34,5.81,11.54 c0.79,0.66,1.61,1.25,2.46,1.78c3.19,1.97,6.83,3,10.93,3.09c0.2,0,0.39,0.01,0.59,0.01h0h32.23c0.19,0,0.38,0,0.57-0.01 c4.06-0.09,7.68-1.1,10.85-3.03c0.89-0.54,1.74-1.15,2.56-1.84c3.81-3.2,5.75-7.05,5.81-11.54c0-0.07,0-0.14,0-0.21v-0.04V24.29 v-0.02C93.75,24.21,93.75,24.14,93.75,24.08z",
    style: {
      fill: "rgb(232, 78, 15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.83,22.37c0-0.02,0-0.04,0-0.06c0.01-0.35,0.01-0.69-0.01-1.03c0-0.09,0-0.18,0-0.27 c0-0.69-0.11-1.39-0.27-2.06c-0.1-0.43-0.23-0.84-0.37-1.26c-0.59-1.79-1.54-3.4-2.74-4.77C46.8,9.84,42.9,7.86,38.68,7.77 c-0.17,0-0.34,0-0.5-0.01c-0.15-0.01-0.31-0.01-0.46-0.02c-4.03-0.08-8.06-0.06-12.19-0.04c-0.76,0-1.52,0-2.27-0.01 c-0.14,0-0.26,0.01-0.37,0.02c-0.31,0-0.62,0-0.93,0c0,4.62-0.01,9.05,0.01,13.47c0,0.02,0,0.04,0,0.06 c-0.01,0.35-0.01,0.69,0.01,1.03c0,0.09,0,0.18,0,0.27c0,0.69,0.11,1.39,0.27,2.06c0.1,0.43,0.23,0.84,0.37,1.26 c0.59,1.79,1.54,3.4,2.73,4.77c2.65,3.09,6.55,5.08,10.77,5.17c0.17,0,0.34,0,0.51,0.01c0.15,0.01,0.31,0.01,0.46,0.02 c4.02,0.08,8.05,0.06,12.18,0.04c0.76,0,1.52,0,2.28,0.01c0.14,0,0.26-0.01,0.37-0.02c0.31,0,0.62,0,0.93,0 C52.84,31.23,52.84,26.8,52.83,22.37z",
    style: {
      fill: "rgb(232, 78, 15)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangedevLogo);
export default __webpack_public_path__ + "static/media/orangedev-logo.7c8d3ad4c15fad1445a7eabd621f8f63.svg";
export { ForwardRef as ReactComponent };